
const generateMatches = (roundOf) => {
  const rounds = Math.log(roundOf) / Math.log(2) - 1
  const nextLayer = (places) => {
    const out = []
    const length = places.length * 2 + 1
    places.forEach(d => {
      out.push(d)
      out.push(length - d)
    })
    return out
  }

  let pls = [1, 2]
  if (roundOf === 1) {
    pls = [1]
  }

  for (let i = 0; i < rounds; i += 1) {
    pls = nextLayer(pls)
  }

  const bottom = pls.splice(pls.length / 2, pls.length / 2)
  pls = pls.concat(bottom.reverse())

  const numberMatches = pls.length / 2

  if (numberMatches < 1) {
    return pls
  }

  const matchList = new Array(numberMatches)

  pls.forEach((item, index) => {
    if (index % 2 === 0) {
      const p1 = item
      const p2 = pls[index + 1]

      matchList[index / 2] = [p1, p2]
    }
  })

  return matchList
}

const calcNumberRounds = (numberParticipants) => {
  let rounds = 1
  while (numberParticipants / (2 ** rounds) > 1) {
    rounds += 1
  }
  return rounds
}

export {
  generateMatches,
  calcNumberRounds
}
